export const flashcardsBySubject = {
  organs: [
    {
      id: 1,
      question: "What organ is this?",
      answer: "Pancreas",
      image: "https://gastrofl.com/wp-content/uploads/2024/03/Inflamed-Pancreas-scaled.jpg"
    },
    {
      id: 2,
      question: "What organ is this?",
      answer: "Spleen",
      image: "https://www.news-medical.net/image-handler/ts/20170516012915/ri/673/picture/2017/5/shutterstock_127653206.jpg"
    },
    {
      id: 3,
      question: "What organ is this?",
      answer: "Heart",
      image: "https://radiologyassistant.nl/assets/cardiac-anatomy/a5097978b7ce42_4-chamber.jpg"
    },
    {
      id: 4,
      question: "What body part is this?",
      answer: "Eye",
      image: "https://media.springernature.com/full/springer-static/image/art%3A10.1038%2Feye.2015.39/MediaObjects/41433_2015_Article_BFeye201539_Fig1_HTML.jpg?as=webp"
    },
    {
      id: 5,
      question: "What organ is this?",
      answer: "Liver",
      image: "https://www.hopkinsmedicine.org/-/media/images/health/1_-conditions/liver-gallbladder-and-pancreas/liver-health-teaser-image.jpg"
    },
    {
      id: 6,
      question: "What organ is this?",
      answer: "Brain",
      image: "https://prod-images-static.radiopaedia.org/images/4170261/c5d7c3ed6c7fe53e59c2dd902e44b9_big_gallery.jpg"
    },
    {
      id: 7,
      question: "What organ is this?",
      answer: "Kidney",
      image: "https://web.stanford.edu/dept/radiology/radiologysite/images/Med%20students%2014,%20kidney/Kidney,%20normal%20in%20different%20planes%20a+%20phases%20(5).png"
    },
    // {
    //   id: 8,
    //   question: "What organ is this?",
    //   answer: "Bladder",
    //   image: "http://radiologycases.my/2020/12/18/squamous-cell-carcinoma-of-urinary-bladder/"
    // },
    {
      id: 9,
      question: "What organ is this?",
      answer: "Appendix",
      image: "https://www.meddean.luc.edu/lumen/meded/radio/nuc_med/appendicitis/images/yyctnr1.jpg"
    },
    {
      id: 10,
      question: "What organ is this?",
      answer: "Gallbladder",
      image: "https://uoflhealth.org/wp-content/uploads/2021/11/gallbladder.jpg"
    },

  ],
  
  cars: [
    {
      id: 11,
      question: "What car brand is this logo?",
      answer: "Mercedes-Benz",
      image: "https://images.unsplash.com/photo-1617814076367-b759c7d7e738?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 12,
      question: "What sports car is this?",
      answer: "Bugatti",
      image: "https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 13,
      question: "What luxury car is this?",
      answer: "Mercedes-Benz",
      image: "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 14,
      question: "What car model is this?",
      answer: "Tesla Roadster",
      image: "https://images.unsplash.com/photo-1617788138017-80ad40651399?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 15,
      question: "What classic car is this?",
      answer: "Volkswagen Beetle",
      image: "https://www.vw.com/content/dam/onehub_pkw/importers/us/en/newsroom/lifestyle-heritage/an-ode-to-the-bug/general/VW_NGW6_Newsroom_Lifestyle-Heritage_An-ode-to-the-bug_Pink-Beetle-Car.jpg"
    },
    {
      id: 16,
      question: "What SUV is this?",
      answer: "Range Rover",
      image: "https://vehicle-images.dealerinspire.com/0636-110008817/SAL119E98SA432242/dfdfba7028472a10317b47370047775c.jpg"
    },
    {
      id: 17,
      question: "What Japanese car is this?",
      answer: "Toyota Prius",
      image: "https://images.unsplash.com/photo-1617788138017-80ad40651399?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 18,
      question: "What sports car is this?",
      answer: "Porsche 911",
      image: "https://newsroom.porsche.com/.imaging/mte/porsche-templating-theme/image_1080x624/dam/pnr/2024/Products/992-II/0840_nevada_coupe_u-crane_AKOS0607_edit_V03-sky.jpg/jcr:content/0840_nevada_coupe_u-crane_AKOS0607_edit_V03-sky.jpg"
    },
    {
      id: 19,
      question: "What muscle car is this?",
      answer: "Ford Mustang",
      image: "https://static.overfuel.com/dealers/trust-auto/image/2020-ford-mustang-shelby-gt350-heritage-edition-3-1024x640.jpg"
    },
    {
      id: 20,
      question: "What supercar is this?",
      answer: "Lamborghini Aventador",
      image: "https://res.cloudinary.com/unix-center/image/upload/c_limit,dpr_3.0,f_auto,fl_progressive,g_center,h_580,q_75,w_906/kxxsmpxaopxf5gzec22w.jpg"
    }
  ],
  
  animals: [
    {
      id: 21,
      question: "What animal is this?",
      answer: "Lion",
      image: "https://images.unsplash.com/photo-1546182990-dffeafbe841d?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 22,
      question: "What bird is this?",
      answer: "Eagle",
      image: "https://www.nationaleaglecenter.org/wp-content/uploads/2022/05/eagle-glossary-img.jpg"
    },
    {
      id: 23,
      question: "What marine animal is this?",
      answer: "Dolphin",
      image: "https://images.unsplash.com/photo-1570481662006-a3a1374699e8?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 24,
      question: "What big cat is this?",
      answer: "Tiger",
      image: "https://i.natgeofe.com/k/07176791-9577-4e31-b101-b10ca7ca9a3c/Stripes_Tiger-Terrific_KIDS_0722_2x1.jpg"
    },
    {
      id: 25,
      question: "What African animal is this?",
      answer: "Elephant",
      image: "https://cdn.mos.cms.futurecdn.net/v2/t:0,l:240,cw:1440,ch:1080,q:80,w:1440/TVR7E3Kuzg2iRhKkjZPeWk.jpg"
    },
    {
      id: 26,
      question: "What primate is this?",
      answer: "Gorilla",
      image: "https://s28164.pcdn.co/files/gorilla-1920x1080-2024-600x400.jpg"
    },
    {
      id: 27,
      question: "What Arctic animal is this?",
      answer: "Polar Bear",
      image: "https://files.worldwildlife.org/wwfcmsprod/images/Polar_Bear_WW225900/story_full_width/82vwzbxa5k_pb_Original_WW225900.jpg"
    },
    {
      id: 28,
      question: "What tall animal is this?",
      answer: "Giraffe",
      image: "https://d1jyxxz9imt9yb.cloudfront.net/animal/806/meta_twitter_image/regular/WR202206_GiraffeTranslocation_012_360559_reduced.jpg"
    },
    {
      id: 29,
      question: "What striped animal is this?",
      answer: "Zebra",
      image: "https://upload.wikimedia.org/wikipedia/commons/4/45/Equus_quagga_burchellii_-_Etosha%2C_2014.jpg"
    },
    {
      id: 30,
      question: "What Australian animal is this?",
      answer: "Kangaroo",
      image: "https://i.natgeofe.com/n/9e934103-53e7-4553-be0e-b1823732b005/Kangaroo-12003_16x9.jpg?w=1200"
    }
  ],
  
  food: [
    {
      id: 31,
      question: "What Italian dish is this?",
      answer: "Pizza",
      image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 32,
      question: "What Japanese dish is this?",
      answer: "Sushi",
      image: "https://images.unsplash.com/photo-1617196034796-73dfa7b1fd56?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 33,
      question: "What French pastry is this?",
      answer: "Croissant",
      image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 34,
      question: "What Mexican dish is this?",
      answer: "Tacos",
      image: "https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 35,
      question: "What dessert is this?",
      answer: "Ice Cream",
      image: "https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 36,
      question: "What breakfast food is this?",
      answer: "Pancakes",
      image: "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 37,
      question: "What tropical fruit is this?",
      answer: "Pineapple",
      image: "https://images.unsplash.com/photo-1550258987-190a2d41a8ba?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 38,
      question: "What comfort food is this?",
      answer: "Hamburger",
      image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 39,
      question: "What Indian dish is this?",
      answer: "Curry",
      image: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=400&h=400&fit=crop&crop=center"
    },
    {
      id: 40,
      question: "What Chinese dish is this?",
      answer: "Dumplings",
      image: "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=400&h=400&fit=crop&crop=center"
    }
  ]
};

export const subjects = [
  { key: 'organs', name: 'Organs', icon: '🫀', color: '#E91E63' },
  { key: 'cars', name: 'Cars & Vehicles', icon: '🚗', color: '#2196F3' },
  { key: 'animals', name: 'Animals', icon: '🦁', color: '#4CAF50' },
  { key: 'food', name: 'Food & Cuisine', icon: '🍕', color: '#FF9800' }
];

// Keep backward compatibility
export const sampleFlashcards = [
  ...flashcardsBySubject.organs,
  ...flashcardsBySubject.cars,
  ...flashcardsBySubject.animals,
  ...flashcardsBySubject.food
]; 